import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ALL_PAYMENT_METHOD_OPTIONS } from 'utils/constants'

type FilterOptions = {
  hasAtm?: boolean
  customerGsPayContactId?: string
  paymentMethodsData?: Record<string, any>
  paymentMethods?: Array<any>
  // For simpler filtering when we don't need complex logic
  simpleFilter?: boolean
}

export const useFilteredPaymentMethods = ({
  hasAtm = false,
  customerGsPayContactId,
  paymentMethodsData,
  paymentMethods = [],
  simpleFilter = false,
}: FilterOptions = {}) => {
  const { enableGreensparkPayFF } = useSelector((state: any) => state.featureFlags?.variables || {})
  const { details } = useSelector((state: any) => state.settings)
  const yardHasGsPayConfigured = details.gsPayEnabled

  return useMemo(() => {
    // Simple filtering for components that just need ATM/GS Pay checks
    if (simpleFilter) {
      return ALL_PAYMENT_METHOD_OPTIONS?.filter(
        method => (hasAtm ? true : method.id !== 'atm') && (yardHasGsPayConfigured ? true : method.id !== 'gs_pay'),
      )
    }

    // Full filtering logic for payment processing components
    return ALL_PAYMENT_METHOD_OPTIONS?.filter(method => {
      if (paymentMethodsData && !(method.id in paymentMethodsData)) {
        return false
      }

      if (method.id === 'gs_pay') {
        return enableGreensparkPayFF && yardHasGsPayConfigured && customerGsPayContactId && paymentMethods.length <= 1
      }

      if (method.id === 'atm') {
        return hasAtm
      }

      return true
    })
  }, [
    hasAtm,
    yardHasGsPayConfigured,
    customerGsPayContactId,
    paymentMethodsData,
    paymentMethods,
    simpleFilter,
    enableGreensparkPayFF,
  ])
}
